import { Skeleton } from '@mantine/core';
import { HoldingsCardsStyles } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/HoldingsCard/HoldingsCards.styles.tsx';
import { EMPTY_CARD_STATE_HEIGHT } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/InvestorDetailsEmptyCardState/InvestorDetailsEmptyCardState.styles.tsx';

const PLACEHOLDER_COUNT = 2;

export const HoldingsCardsSkeleton = () => {
	return (
		<HoldingsCardsStyles>
			{Array.from({ length: PLACEHOLDER_COUNT }, (_, index) => (
				<Skeleton key={index} height={EMPTY_CARD_STATE_HEIGHT} radius="0.25rem" />
			))}
		</HoldingsCardsStyles>
	);
};
